import AltPhone from "@components/User/shared/AltPhone";
import Name from "@components/User/shared/Name";
import Email from "@hudson/ui/components/FormFields/Email";
import Phone from "@hudson/ui/components/FormFields/Phone";
import useContent from "@lib/use_content";

export default function ContactSection({}) {
  const { data, loading } = useContent([
    "beErrEmailFormat",
    "beErrPhoneFormat",
    "bePudPersonAltphoneLabel",
    "bePudPersonContactSectionTitle",
    "bePudPersonEmailLabel",
    "bePudPersonFaxLabel",
    "bePudPersonNameLabel",
    "bePudPersonPhoneLabel",
  ]);

  return (
    <div>
      <div className="mt-8 mb-6 space-y-1">
        <h3 className="text-xl font-bold leading-6 text-gray-900">
          {data?.content.bePudPersonContactSectionTitle}
        </h3>
      </div>
      <div className="grid grid-cols-1 gap-y-6 sm:grid-cols-2 sm:gap-x-4 ">
        {data?.content.bePudPersonNameLabel && (
          <Name fieldName="pudName" label={data?.content.bePudPersonNameLabel} />
        )}

        {data?.content.beErrEmailFormat && (
          <Email
            errorFormatMessage={data?.content.beErrEmailFormat}
            fieldName="email"
            label={data?.content.bePudPersonEmailLabel}
            widthClass="w-64"
          />
        )}

        {data?.content.bePudPersonPhoneLabel && (
          <Phone
            errorFormatMessage={data?.content.beErrPhoneFormat}
            fieldName="telephone"
            label={data?.content.bePudPersonPhoneLabel}
          />
        )}

        {data?.content.bePudPersonAltphoneLabel && (
          <AltPhone
            errorFormatMessage={data?.content.beErrPhoneFormat}
            fieldName="telephone2"
            label={data?.content.bePudPersonAltphoneLabel}
          />
        )}

        {data?.content.bePudPersonFaxLabel && (
          <AltPhone
            errorFormatMessage={data?.content.beErrPhoneFormat}
            fieldName="faxNumber"
            label={data?.content.bePudPersonFaxLabel}
          />
        )}
      </div>
    </div>
  );
}
